// @flow
import React from 'react';
import { reloadApp, openSupportWhatsApp, SUPPORT_ERROR_WHATSAPP_URL } from '../../../helpers/appRecovery';
import './ErrorBoundaryView.scss';

type Props = {
  title?: string,
  message?: ?string,
};

// What's left when a screen breaks: one tap reloads the app, instead of force-quitting it. Plain elements
// and fixed Portuguese text: whatever broke (translations, the store) must not take this screen down too.
const CrashScreen = ({ title = 'Algo deu errado', message }: Props) => (
  <div id="errorBoundaryView" className="crashScreen" role="alert">
    <h1>{title}</h1>
    <p className="crashScreen-text">
      O Doutore teve um problema e não conseguiu mostrar esta tela. Toque em Recarregar para voltar ao início.
    </p>
    <button type="button" className="crashScreen-reload" onClick={reloadApp}>Recarregar</button>
    <a
      className="crashScreen-support"
      href={SUPPORT_ERROR_WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={openSupportWhatsApp}
    >
      Falar com o suporte
    </a>
    {message && <p className="crashScreen-detail">Detalhe: {message}</p>}
  </div>
);

export default CrashScreen;
